import { render, staticRenderFns } from "./OrdersFinishedView.vue?vue&type=template&id=6538a43d"
import script from "./OrdersFinishedView.vue?vue&type=script&lang=js"
export * from "./OrdersFinishedView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports